import {
   ChronicDiseaseSimpleQuery,
   MedicalInformationCountByType,
   MedicalInformationCountByTypeQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCount, useCqrsSearch } from '@dreryk/command-query-react-common';
import { PromiseVoidFunction } from '@dreryk/react-common';

import { SidePanelLoader } from '../SidePanelLoader';

type MedicalDataSidePanelContentLoaderRenderer = (renderProps: {
   chronicDiseaseCount: number | undefined;
   medicalInformationCountByType: MedicalInformationCountByType[] | undefined;
   refetchMedicalInformationCountByType: PromiseVoidFunction;
}) => JSX.Element;

type MedicalDataSidePanelContentLoaderProps = {
   readonly patientId: number;
   readonly children: MedicalDataSidePanelContentLoaderRenderer;
};

export const MedicalDataSidePanelContentLoader = (props: MedicalDataSidePanelContentLoaderProps): JSX.Element => {
   const { data: chronicDiseaseCount, loading: chronicDiseaseCountLoading } = useCqrsCount(() => {
      const query = new ChronicDiseaseSimpleQuery();
      query.patientId = props.patientId;
      return query;
   });

   const {
      data: medicalInformationCountByType,
      loading: medicalInformationCountByTypeLoading,
      refetch: refetchMedicalInformationCountByType,
   } = useCqrsSearch<MedicalInformationCountByType>(() => {
      const query = new MedicalInformationCountByTypeQuery();
      query.patientId = props.patientId;
      return query;
   });

   if (medicalInformationCountByTypeLoading || chronicDiseaseCountLoading) {
      return <SidePanelLoader />;
   }

   return props.children({
      chronicDiseaseCount: chronicDiseaseCount,
      medicalInformationCountByType: medicalInformationCountByType,
      refetchMedicalInformationCountByType: refetchMedicalInformationCountByType,
   });
};
